// extracted by mini-css-extract-plugin
export default {"index-page":"ProjectsPage-module__index-page___xw2GU","project-button__wrapper":"ProjectsPage-module__project-button__wrapper___Xa_ZK"};